
















      
import Vue from 'vue'  
import Component from 'vue-class-component'  
 import {loadLanguageAsync,locales} from '@/locale/vueI18n'  

@Component({
  name: 'LangSwitcher',    
})
export default class LangSwitcher extends Vue {  
      
    setLang(lang:string) {
      loadLanguageAsync(lang)
    }

    get locales(){
      return locales
    }
}
